import axios from 'axios';
import { isProductionEnvironment, isStageEnvironment } from 'utils/environment';
import { OrderAssortmentData } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/mock/oders-assortment.mock';
import { RecommendationAssortmentData } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/mock/recommendation-assortment.mock';
import { OrderAssortment } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/order-assortment.type';
import { RecommendationAssortment } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/recommendation-assortment.type';

/**
 * Get Order Overview
 * @param customerErpId
 * @param siteErpId
 * @returns
 */
export const getOrderAssortment = async (customerErpId: string, siteErpId: string): Promise<OrderAssortment> => {
//   if (!isProductionEnvironment && !isStageEnvironment) return OrderAssortmentData;
  const res = await axios.get(`/ewosapi/v1/order?customerErpId=${customerErpId}&siteErpId=${siteErpId}`);
  return res.data;
};

/**
 * Get Recommendations, displayed to the user as Forecasts.
 */
export const getRecommendationAssortment = async (siteErpId: string): Promise<RecommendationAssortment> => {
  if (!isProductionEnvironment && !isStageEnvironment) return RecommendationAssortmentData;
  const res = await axios.get(`/ewosapi/v1/recommendations/site?globalSiteId=${siteErpId}`);
  return res.data;
};
